module.exports = __webpack_public_path__ + "public/PaymentGateway/paypal.svg?a06502ba";